<div class="entry-cover" *ngIf="image">
    <div class="entry-cover-image" style="background-image: url({{image.url}})" [title]="image.alt">
    </div>
    <header class="entry-header">
        <div class="entry-info">
            <h1 class="entry-title">{{ 'data.blog.title' | translate }} {{ title ? ' - ' + title : title }}</h1>
        </div>
    </header>
</div>
<div class="container police">
    <div class="column mt-2 mb-5">
        <div class="flex-container-1 mt-3" *ngFor="let article of articles">
            <!-- main container -->

            <div class="flex-item" [routerLink]="['/article' | localize, article.slugId, article.slug]" style="cursor: pointer;">
                <img style="max-width: 100%;max-height: 100%;" [src]="article.thumbnail"
                    [alt]="article.thumbnailAlt">
            </div><!-- flex item #1 (first column) -->

            <div class="flex-container-2">
                <!-- flex item #2 / nested flex container (second column) -->

                <div class="flex-item">
                    <div class="share" style="color: #00a4cb;cursor: pointer;" (click)='showShareModal(article)'>
                        <i color="#00a4cb" class="fas fa-share"></i>
                        {{'data.share' | translate}}
                    </div>
                    <div [routerLink]="['/article' | localize, article.slugId, article.slug]" style="cursor: pointer;">
                      <h2 style="margin-bottom: 2px">{{ article.title }}
                      </h2>
                      <div style="cursor: pointer;">
                        <p class="description">
                          {{ article.description }}
                        </p>
                      </div>
                    </div>
                </div>
            </div><!-- close nested container -->
            <a [routerLink]="['/article' | localize, article.slugId, article.slug]" class="flex-item button">
              <app-button (cta)="goToArticle(article)" [title]="'data.blog.button' | translate"
                  [isSmall]="isSmall" [nextButton]="faArrowCircleRight" [isLink]="true">
              </app-button>
            </a>
        </div><!-- close main container -->

        <div *ngIf="articles" class="col-md-12 justify-content-center mt-3">
            <ngb-pagination [(page)]="page" [pageSize]="pageSize" [collectionSize]="totalSize"
                (pageChange)="getCurrentPage($event)"></ngb-pagination>
        </div>

    </div>
</div>
